import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Wrapper from "../wrapper/Wrapper";
import LoadScript from "react-load-script";
import * as UTIL from "../../util";
export var RetailWriteAReview = function RetailWriteAReview(props) {
  var _props$rendered = props.rendered,
      rendered = _props$rendered === void 0 ? {} : _props$rendered;

  var handleScriptLoad = function handleScriptLoad() {
    var _POWERREVIEWS$display;

    var POWERREVIEWS = window.POWERREVIEWS || {};
    var queryParams = UTIL.queryJSON();
    POWERREVIEWS === null || POWERREVIEWS === void 0 ? void 0 : (_POWERREVIEWS$display = POWERREVIEWS.display) === null || _POWERREVIEWS$display === void 0 ? void 0 : _POWERREVIEWS$display.render({
      api_key: queryParams.pr_api_key,
      merchant_group_id: queryParams.pr_merchant_group_id,
      merchant_id: queryParams.pr_merchant_id,
      page_id: queryParams.pr_page_id,
      on_submit: function on_submit(config, data) {
        window.scrollTo(0, 0);
      },
      components: {
        Write: 'pr-write'
      }
    });
  };

  var layout = {
    background: (rendered === null || rendered === void 0 ? void 0 : rendered.Background) || "default",
    padding: (rendered === null || rendered === void 0 ? void 0 : rendered.Padding) || "medium"
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    id: "pr-write"
  }, /*#__PURE__*/React.createElement(LoadScript, {
    url: "//ui.powerreviews.com/stable/4.0/ui.js",
    onLoad: handleScriptLoad
  }))))));
};